module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed-element"
  }, [_c('div', {
    staticClass: "interaction-avatar pull-left"
  }, [(_vm.interaction.ore.profile_image) ? _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.interaction.ore.profile_image[0].value
    },
    on: {
      "error": function($event) {
        return _vm.imageLoadOnError()
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-user-circle fa-3x"
  }), _vm._v(" "), _c('div', {
    staticClass: "interaction-type img-circle",
    class: _vm.interaction.type
  }, [_c('i', {
    staticClass: "fa fa-sm",
    class: _vm.iconClasses[_vm.interaction.type]
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('small', {
    staticClass: "text-muted pull-right interaction-date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.interaction.date_created, 'HH:MM Do MMM YYYY ')))]), _vm._v(" "), _c('div', {
    staticClass: "interaction-originator"
  }, [_vm._v(_vm._s(_vm.interaction.ore.originators[0].value))]), _vm._v(" "), (_vm.mediaExists) ? _c('div', {
    staticClass: "interaction-media"
  }, [(_vm.interaction.ore.image) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'image')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.interaction.ore.video) ? _c('video', {
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'video'),
      "controls": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.interaction.ore.audio) ? _c('audio', {
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'audio'),
      "controls": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "interaction-message"
  }, [_vm._v(_vm._s(_vm.interaction.ore.message[0].value))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interaction-tools"
  }, [_c('a', {
    staticClass: "onair"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('a', {
    staticClass: "reply"
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })]), _vm._v(" "), _c('a', {
    staticClass: "comment"
  }, [_c('i', {
    staticClass: "fa fa-comment"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03a45a7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/Interaction.vue
// module id = 3117
// module chunks = 3